const __WEBPACK_NAMESPACE_OBJECT__ = {DOMParser: DOMParser};